module.exports = __webpack_public_path__ + "static/media/order.3fc530e1.svg";